<template>
    <div>
        <!-- sub category form -->
        <div class="p-col-12 p-md-9 p-mx-auto box p-p-4">
            <div class="p-field p-text-right">
                <Button 
                    label="Add Sub Category"
                    @click="newsSubCategoryForm.visible = !newsSubCategoryForm.visible"
                    class="p-col p-button-outlined p-button-info p-button-text" />
            </div>

            <div class="p-fluid p-formgrid p-grid p-text-left p-mt-2"
                v-show="newsSubCategoryForm.visible">
                <div class="p-field p-col-12 p-md-6">
                    <Dropdown class="p-text-left" placeholder="Select Source"
                        v-model="newsSubCategoryForm.source" :options="newsSources"
                        optionLabel="name" optionValue="id"
                        style="width:100%" />
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <span class="p-float-label">
                        <InputText id="title" type="text" v-model="newsSubCategoryForm.title" />
                        <label for="title">Title</label>
                    </span>
                </div>
                <div class="p-field p-col-12 p-md-12 p-mt-2">
                    <span class="p-float-label">
                        <InputText id="url" type="text" v-model="newsSubCategoryForm.url" />
                        <label for="url">URL</label>
                    </span>
                </div>
                <div class="p-field-checkbox p-col-12 p-md-12 p-mt-2">
                    <Checkbox id="add_automatically" v-model="newsSubCategoryForm.add_automatically" :binary="true" />
                    <label for="add_automatically" class="p-ml-2">Add automatically with cronjob</label>
                </div>
                <div class="p-field p-col-12 p-md-12 p-mt-2">
                    <span class="p-float-label">
                        <Textarea id="comment" type="url" :autoResize="true" v-model="newsSubCategoryForm.comment" />
                        <label for="comment">Comment</label>
                    </span>
                </div>
                <div class="p-col-12 p-md-12">
                    <div class="p-field p-text-right">
                        <Button 
                            label="Add News Sub Category"
                            @click="addNewsSubCategory()"
                            :loading="isAddingNewsSubCategory"
                            class="p-button-outlined p-button-info p-button-text" />
                    </div>
                </div>
            </div>
        </div>

        <!-- sub category list -->
        <div class="p-grid p-mx-auto">
            <div class="p-col-12 p-md-10 p-mx-auto">
                <DataTable v-show="newsSubCategoryList !== null && newsSubCategoryList.length > 0" :paginator="false" :rowHover="true"
                    :value="newsSubCategoryList" dataKey="id" responsiveLayout="scroll"
                    :loading="isNewsSubCategoryListLoading" >
                    <Column field="id" header="#" sortable style="width:5%"></Column>
                    <Column field="source" header="Source" sortable style="width:5%"></Column>
                    <Column field="title" header="Title" style="width:15%"></Column>
                    <Column field="add_automatically" sortable header="Add automatically" style="width:15%">
                        <template #body="{data}">
                            <div class="p-text-center">
                                <Checkbox id="is_enabled" class="p-text-center"
                                    v-model="data.add_automatically" :binary="true" :disabled="true" />
                            </div>
                        </template>
                    </Column>
                    <Column field="url" header="URL" style="width:10%">
                        <template #body="{data}">
                            <a :href="data.url" target="_blank">{{data.url}}</a>
                        </template>
                    </Column>
                    <Column field="comment" header="Comment" style="width:30%"></Column>
                    <Column header="" style="width:20%">
                        <template #body="item">
                            <Button label="" icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-plain"
                                @click="editNewsSubCategory(item.data, item.index)" />
                            <Button label="" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-plain"
                                @click="deleteNewsSubCategory(item.data.id, item.index)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>

        <!-- edit sub category modal -->
        <Dialog v-model:visible="updateNewsSubCategoryForm.visible"
            header="Update Sub Category" :modal="true" class="p-fluid p-col-6">
            <div class="p-fluid p-formgrid p-grid p-text-left">
                <div class="p-field p-col-12 p-md-6 p-mt-2">
                    <Dropdown class="p-text-left" placeholder="Select Source"
                        v-model="updateNewsSubCategoryForm.item.source" :options="newsSources"
                        optionLabel="name" optionValue="id"
                        style="width:100%" />
                </div>
                <div class="p-field p-col-12 p-md-6 p-mt-2">
                    <span class="p-float-label">
                        <InputText id="title" type="text" v-model="updateNewsSubCategoryForm.item.title" />
                        <label for="title">Title</label>
                    </span>
                </div>
                <div class="p-field p-col-12 p-md-12 p-mt-4">
                    <span class="p-float-label">
                        <InputText id="url" type="text" v-model="updateNewsSubCategoryForm.item.url" />
                        <label for="url">URL</label>
                    </span>
                </div>
                <div class="p-field-checkbox p-col-12 p-md-12 p-mt-2">
                    <Checkbox id="add_automatically" v-model="updateNewsSubCategoryForm.item.add_automatically" :binary="true" />
                    <label for="add_automatically" class="p-ml-2">Add automatically with cronjob</label>
                </div>
                <div class="p-field p-col-12 p-md-12 p-mt-4">
                    <span class="p-float-label">
                        <Textarea id="comment" type="url" :autoResize="true" v-model="updateNewsSubCategoryForm.item.comment" />
                        <label for="comment">Comment</label>
                    </span>
                </div>
                <div class="p-col-12 p-md-12">
                    <div class="p-field p-text-right">
                        <Button 
                            label="Update Sub Category"
                            @click="updateNewsSubCategory()"
                            :loading="isUpdatingNewsSubCategory"
                            class="p-button-outlined p-button-info p-button-text" />
                    </div>
                </div>
            </div>
        </Dialog>
    </div>
</template>


<script>
import Const from '../utils/const'
import { isEmpty } from '../utils/utils'

import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import Checkbox from 'primevue/checkbox'
import Textarea from 'primevue/textarea'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'

export default {
    name: 'News Sources Sub Categories',
    components: {
        Dropdown, InputText, Checkbox, Textarea, Button, DataTable, Column, Dialog
    },
    data() {
        return {
            newsSources: [
                { id: Const.NewsSource.NTVSpor, name: 'NTVSpor' },
                { id: Const.NewsSource.SporX, name: 'SporX' },
                { id: Const.NewsSource.Fanatik, name: 'Fanatik' },
                { id: Const.NewsSource.Fotomac, name: 'Fotomaç' },
                { id: Const.NewsSource.Mynet, name: 'Mynet' },
                { id: Const.NewsSource.Mackolik, name: 'Maçkolik' },
                { id: Const.NewsSource.Beinsports, name: 'Beinsports' }
            ],
            isAddingNewsSubCategory: false,
            newsSubCategoryForm: { visible: false },
            isNewsSubCategoryListLoading: false,
            isUpdatingNewsSubCategory: false,
            newsSubCategoryList: [],
            updateNewsSubCategoryForm: { visible: false, index: -1, item: null },
        }
    },
    emits: ["loginResult", "pageLoaded"],
    beforeMount() {
        var page = {
            title: 'News Sources Sub Categories'
        }
        this.$emit('pageLoaded', page)
    },
    mounted() {
        this.getNewsSubCategoryList()
    },
    methods: {
        async getNewsSubCategoryList() {
            let self = this,
                cookies = self.$cookies,
                toast = self.$toast,
                token = cookies.get('token');
            
            try {
                self.isNewsSubCategoryListLoading = true
                
                let response = await self.$http.get('api/news-sub-categories', {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                })

                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    self.newsSubCategoryList = response.data.items

                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    throw response.data.mesaj
                }
            } catch(error) {
                toast.add({severity:'warn', summary: 'Loading news sub category list failed', detail: error, life: 3000});
            } finally {
                self.isNewsSubCategoryListLoading = false
            }
        },
        editNewsSubCategory(subCategory, index) {
            let newItem = {
                id: subCategory.id,
                source: subCategory.source,
                title: subCategory.title,
                url: subCategory.url,
                add_automatically: subCategory.add_automatically,
                comment: subCategory.comment
            }

            this.updateNewsSubCategoryForm.index = index
            this.updateNewsSubCategoryForm.item = newItem
            this.updateNewsSubCategoryForm.visible = true
        },
        async addNewsSubCategory() {
            let self = this,
                toast = self.$toast,
                newsSubCategoryForm = self.newsSubCategoryForm,
                toastMessage = null,
                cookies = self.$cookies,
                token = cookies.get('token');

            if(isEmpty(newsSubCategoryForm.source)) {
                toastMessage = 'News source is not selected!'
            } else if(isEmpty(newsSubCategoryForm.title)) {
                toastMessage = 'Title is empty!'
            } else if(isEmpty(newsSubCategoryForm.url)) {
                toastMessage = 'URL is empty!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            try {
                self.isAddingNewsSubCategory = true
                let response = await self.$http.post('api/news-sub-categories', newsSubCategoryForm, {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                })

                cookies.set('token', response.headers['refresh-token']);
                let newAddedItem = response.data.item
                
                self.newsSubCategoryList.push(newAddedItem)

                self.newsSubCategoryForm = { visible: true }
            } catch(error) {
                console.log(error)
                toast.add({severity:'error', summary: 'Error!', detail: error, life: 3000});
            } finally {
                self.isAddingNewsSubCategory = false
            }
        },
        async updateNewsSubCategory() {
            let self = this,
                toast = self.$toast,
                subCategoryFormItem = self.updateNewsSubCategoryForm.item,
                itemIndex = self.updateNewsSubCategoryForm.index,
                toastMessage = null,
                cookies = self.$cookies,
                token = cookies.get('token');

            if(isEmpty(subCategoryFormItem.source)) {
                toastMessage = 'News source is not selected!'
            } else if(isEmpty(subCategoryFormItem.title)) {
                toastMessage = 'Title is empty!'
            } else if(isEmpty(subCategoryFormItem.url)) {
                toastMessage = 'URL is empty!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            try {
                self.isUpdatingNewsSubCategory = true
                let response = await self.$http.put(`api/news-sub-categories/${subCategoryFormItem.id}`, subCategoryFormItem, {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                })

                cookies.set('token', response.headers['refresh-token']);
                let updatedItem = response.data.item
                
                self.newsSubCategoryList[itemIndex] = updatedItem

                self.updateNewsSubCategoryForm = { visible: false, index: -1, item: null }
            } catch(error) {
                console.log(error)
                toast.add({severity:'error', summary: 'Error!', detail: error, life: 3000});
            } finally {
                self.isUpdatingNewsSubCategory = false
            }
        },
        async deleteNewsSubCategory(subCategoryId, index) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');

            this.$confirm.require({
                message: 'Are you sure you want to delete this sub category?',
                header: 'Delete',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Delete',
                rejectLabel: 'Cancel',
                accept: async function() {
                    
                    try {
                        let response = await self.$http.delete(`api/news-sub-categories/${subCategoryId}`, {
                            headers: {
                                'authorization': 'Bearer ' + token
                            }
                        })

                        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                            cookies.set("token", response.headers['refresh-token']);

                            self.newsSubCategoryList.splice(index, 1);

                            toast.add({severity:'success', summary: 'Success', detail: 'News sub category deleted successfully.', life: 3000});
                        } else {
                            throw response.data.mesaj
                        }
                    } catch(error) {
                        console.log(error)
                        toast.add({severity:'error', summary: 'Error!', detail: error, life: 3000});
                    }
                },
                reject: () => {
                }
            });
        }
    }
}
</script>